//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class SchedulerSettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSchedulerSettings( cancelToken?: CancelToken): Promise<SchedulerSettings> {
        let url_ = this.baseUrl + "/api/cp/settings/scheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchedulerSettings(_response);
        });
    }

    protected processGetSchedulerSettings(response: AxiosResponse): Promise<SchedulerSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchedulerSettings.fromJS(resultData200);
            return Promise.resolve<SchedulerSettings>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Scheduler settings are not configured", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchedulerSettings>(null as any);
    }
}

export class SettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Found settings
     */
    getAllSpecialSettings( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api/cp/settings/special";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSpecialSettings(_response);
        });
    }

    protected processGetAllSpecialSettings(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Found setting
     */
    getServiceTitanSpecialSettings(key: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api/cp/settings/st/special/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceTitanSpecialSettings(_response);
        });
    }

    protected processGetServiceTitanSpecialSettings(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Setting not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Found setting
     */
    getSpecialSettings(key: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api/cp/settings/special/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpecialSettings(_response);
        });
    }

    protected processGetSpecialSettings(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Setting not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Settings updated
     */
    setSpecialSettings(key: string, settings: any, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/settings/special/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSpecialSettings(_response);
        });
    }

    protected processSetSpecialSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Settings for hostname exist
     */
    getSettingsByHostName( cancelToken?: CancelToken): Promise<PublicPlatformSettings> {
        let url_ = this.baseUrl + "/api/cp/settings/host";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingsByHostName(_response);
        });
    }

    protected processGetSettingsByHostName(response: AxiosResponse): Promise<PublicPlatformSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("Settings for hostname do not exist", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicPlatformSettings.fromJS(resultData200);
            return Promise.resolve<PublicPlatformSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPlatformSettings>(null as any);
    }

    /**
     * @return Settings for hostname exist
     */
    getSettingsByHostNameWeb( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/cp/settings/web";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingsByHostNameWeb(_response);
        });
    }

    protected processGetSettingsByHostNameWeb(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Settings ok
     */
    getSettings( cancelToken?: CancelToken): Promise<GetTenantPlatformSettingsResponse> {
        let url_ = this.baseUrl + "/api/cp/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<GetTenantPlatformSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantPlatformSettingsResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantPlatformSettingsResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantPlatformSettingsResponse>(null as any);
    }

    /**
     * @return Settings were updated
     */
    setSettings(platformSettings: TenantPlatformSettings, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(platformSettings);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSettings(_response);
        });
    }

    protected processSetSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Validation errors occured", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Settings ok
     */
    getSystemSettings( cancelToken?: CancelToken): Promise<SystemPlatformSettings> {
        let url_ = this.baseUrl + "/api/cp/settings/system";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSystemSettings(_response);
        });
    }

    protected processGetSystemSettings(response: AxiosResponse): Promise<SystemPlatformSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemPlatformSettings.fromJS(resultData200);
            return Promise.resolve<SystemPlatformSettings>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemPlatformSettings>(null as any);
    }

    shouldSkipCp1Migration( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/cp/settings/should-skip-cp1-migration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShouldSkipCp1Migration(_response);
        });
    }

    protected processShouldSkipCp1Migration(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Settings were migrated
     */
    migrateFromCp1(request: MigrateSettingsFromCp1Request, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/settings/migrate-cp1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateFromCp1(_response);
        });
    }

    protected processMigrateFromCp1(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Validation errors occured", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    uploadLogo(logoUpload: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/cp/settings/logo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logoUpload !== null && logoUpload !== undefined)
            content_.append("logoUpload", logoUpload.data, logoUpload.fileName ? logoUpload.fileName : "logoUpload");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadLogo(_response);
        });
    }

    protected processUploadLogo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Host is valid, but may or may not be available
     */
    isHostAvailable(host: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/cp/settings/host/validate/{host}";
        if (host === undefined || host === null)
            throw new Error("The parameter 'host' must be defined.");
        url_ = url_.replace("{host}", encodeURIComponent("" + host));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsHostAvailable(_response);
        });
    }

    protected processIsHostAvailable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param subdomain (optional) 
     * @return Subdomain is valid, but may or may not be available
     */
    isSubdomainAvailable(subdomain: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/cp/settings/subdomain/validate?";
        if (subdomain === null)
            throw new Error("The parameter 'subdomain' cannot be null.");
        else if (subdomain !== undefined)
            url_ += "Subdomain=" + encodeURIComponent("" + subdomain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsSubdomainAvailable(_response);
        });
    }

    protected processIsSubdomainAvailable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Subdomain has validation errors", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class TenantIdClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    tenantIdFromHost(hostName: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/internal/cp/tenant-id/by-host/{hostName}";
        if (hostName === undefined || hostName === null)
            throw new Error("The parameter 'hostName' must be defined.");
        url_ = url_.replace("{hostName}", encodeURIComponent("" + hostName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTenantIdFromHost(_response);
        });
    }

    protected processTenantIdFromHost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Tenant with the specified host name was not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    tenantIdFromName(tenantName: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/internal/cp/tenant-id/by-name/{tenantName}";
        if (tenantName === undefined || tenantName === null)
            throw new Error("The parameter 'tenantName' must be defined.");
        url_ = url_.replace("{tenantName}", encodeURIComponent("" + tenantName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTenantIdFromName(_response);
        });
    }

    protected processTenantIdFromName(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Tenant with the specified tenant name was not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SchedulerSettings implements ISchedulerSettings {
    schedulingProScriptUrl!: string;
    webSchedulerScriptUrl!: string;

    constructor(data?: ISchedulerSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schedulingProScriptUrl = _data["schedulingProScriptUrl"];
            this.webSchedulerScriptUrl = _data["webSchedulerScriptUrl"];
        }
    }

    static fromJS(data: any): SchedulerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schedulingProScriptUrl"] = this.schedulingProScriptUrl;
        data["webSchedulerScriptUrl"] = this.webSchedulerScriptUrl;
        return data;
    }
}

export interface ISchedulerSettings {
    schedulingProScriptUrl: string;
    webSchedulerScriptUrl: string;
}

export class PublicPlatformSettings implements IPublicPlatformSettings {
    title!: string;
    host!: string;
    email!: string;
    phoneNumber!: string;
    logo!: string;
    bookingEnabled!: boolean;
    tenantId!: number;
    timezoneOffsetMinutes!: number | undefined;
    tenantName!: string | undefined;

    constructor(data?: IPublicPlatformSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.host = _data["host"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.logo = _data["logo"];
            this.bookingEnabled = _data["bookingEnabled"];
            this.tenantId = _data["tenantId"];
            this.timezoneOffsetMinutes = _data["timezoneOffsetMinutes"];
            this.tenantName = _data["tenantName"];
        }
    }

    static fromJS(data: any): PublicPlatformSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPlatformSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["host"] = this.host;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["logo"] = this.logo;
        data["bookingEnabled"] = this.bookingEnabled;
        data["tenantId"] = this.tenantId;
        data["timezoneOffsetMinutes"] = this.timezoneOffsetMinutes;
        data["tenantName"] = this.tenantName;
        return data;
    }
}

export interface IPublicPlatformSettings {
    title: string;
    host: string;
    email: string;
    phoneNumber: string;
    logo: string;
    bookingEnabled: boolean;
    tenantId: number;
    timezoneOffsetMinutes: number | undefined;
    tenantName: string | undefined;
}

export class GetTenantPlatformSettingsResponse implements IGetTenantPlatformSettingsResponse {
    portalEnabled!: boolean;
    name!: string;
    host!: string;
    email!: string;
    phone!: string;
    logo!: string;
    inviteMode!: InviteMode;
    bookingEnabled!: boolean;
    timezoneOffsetMinutes!: number | undefined;

    constructor(data?: IGetTenantPlatformSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalEnabled = _data["portalEnabled"];
            this.name = _data["name"];
            this.host = _data["host"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.inviteMode = _data["inviteMode"];
            this.bookingEnabled = _data["bookingEnabled"];
            this.timezoneOffsetMinutes = _data["timezoneOffsetMinutes"];
        }
    }

    static fromJS(data: any): GetTenantPlatformSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantPlatformSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalEnabled"] = this.portalEnabled;
        data["name"] = this.name;
        data["host"] = this.host;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["inviteMode"] = this.inviteMode;
        data["bookingEnabled"] = this.bookingEnabled;
        data["timezoneOffsetMinutes"] = this.timezoneOffsetMinutes;
        return data;
    }
}

export interface IGetTenantPlatformSettingsResponse {
    portalEnabled: boolean;
    name: string;
    host: string;
    email: string;
    phone: string;
    logo: string;
    inviteMode: InviteMode;
    bookingEnabled: boolean;
    timezoneOffsetMinutes: number | undefined;
}

export enum InviteMode {
    Unspecified = 0,
    None = 1,
    Auto = 2,
    Manual = 3,
}

export class SystemPlatformSettings implements ISystemPlatformSettings {
    baseDomain!: string;

    constructor(data?: ISystemPlatformSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseDomain = _data["baseDomain"];
        }
    }

    static fromJS(data: any): SystemPlatformSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SystemPlatformSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseDomain"] = this.baseDomain;
        return data;
    }
}

export interface ISystemPlatformSettings {
    baseDomain: string;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class TenantPlatformSettings implements ITenantPlatformSettings {
    portalEnabled!: boolean;
    name!: string;
    host!: string | undefined;
    subdomain!: string | undefined;
    email!: string;
    phone!: string;
    logo!: string;
    inviteMode!: InviteMode;
    bookingEnabled!: boolean;
    timezoneOffsetMinutes!: number | undefined;

    constructor(data?: ITenantPlatformSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalEnabled = _data["portalEnabled"];
            this.name = _data["name"];
            this.host = _data["host"];
            this.subdomain = _data["subdomain"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.inviteMode = _data["inviteMode"];
            this.bookingEnabled = _data["bookingEnabled"];
            this.timezoneOffsetMinutes = _data["timezoneOffsetMinutes"];
        }
    }

    static fromJS(data: any): TenantPlatformSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TenantPlatformSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalEnabled"] = this.portalEnabled;
        data["name"] = this.name;
        data["host"] = this.host;
        data["subdomain"] = this.subdomain;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["inviteMode"] = this.inviteMode;
        data["bookingEnabled"] = this.bookingEnabled;
        data["timezoneOffsetMinutes"] = this.timezoneOffsetMinutes;
        return data;
    }
}

export interface ITenantPlatformSettings {
    portalEnabled: boolean;
    name: string;
    host: string | undefined;
    subdomain: string | undefined;
    email: string;
    phone: string;
    logo: string;
    inviteMode: InviteMode;
    bookingEnabled: boolean;
    timezoneOffsetMinutes: number | undefined;
}

export class MigrateSettingsFromCp1Request implements IMigrateSettingsFromCp1Request {
    tenantId!: number;
    subdomain!: string;
    defaultDomain!: string | undefined;
    isLegalAgreementAccepted!: boolean;
    settings!: Cp1PortalSettings;

    constructor(data?: IMigrateSettingsFromCp1Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.subdomain = _data["subdomain"];
            this.defaultDomain = _data["defaultDomain"];
            this.isLegalAgreementAccepted = _data["isLegalAgreementAccepted"];
            this.settings = _data["settings"] ? Cp1PortalSettings.fromJS(_data["settings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MigrateSettingsFromCp1Request {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateSettingsFromCp1Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["subdomain"] = this.subdomain;
        data["defaultDomain"] = this.defaultDomain;
        data["isLegalAgreementAccepted"] = this.isLegalAgreementAccepted;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMigrateSettingsFromCp1Request {
    tenantId: number;
    subdomain: string;
    defaultDomain: string | undefined;
    isLegalAgreementAccepted: boolean;
    settings: Cp1PortalSettings;
}

export class Cp1PortalSettings implements ICp1PortalSettings {
    isEnabled!: boolean;
    isMembershipsEnabled!: boolean;
    isSchedulerEnabled!: boolean;
    host!: string;
    email!: string;
    phone!: string;
    logo!: string;
    companyName!: string;
    downloadInvoiceBusinessUnitIds!: number[] | undefined;
    displayCancelledMemberships!: boolean;
    displayExpiredMemberships!: boolean;
    displaySuspendedMemberships!: boolean;
    displayPendingInvoices!: boolean;
    displayPostedInvoices!: boolean;
    displayExportedInvoices!: boolean;
    displayInvoicesNeedingReview!: boolean;
    displayInvoicesWithReviewOnHold!: boolean;
    displayReviewedInvoices!: boolean;
    recurringServiceEventMessage!: string | undefined;

    constructor(data?: ICp1PortalSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.isMembershipsEnabled = _data["isMembershipsEnabled"];
            this.isSchedulerEnabled = _data["isSchedulerEnabled"];
            this.host = _data["host"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["downloadInvoiceBusinessUnitIds"])) {
                this.downloadInvoiceBusinessUnitIds = [] as any;
                for (let item of _data["downloadInvoiceBusinessUnitIds"])
                    this.downloadInvoiceBusinessUnitIds!.push(item);
            }
            this.displayCancelledMemberships = _data["displayCancelledMemberships"];
            this.displayExpiredMemberships = _data["displayExpiredMemberships"];
            this.displaySuspendedMemberships = _data["displaySuspendedMemberships"];
            this.displayPendingInvoices = _data["displayPendingInvoices"];
            this.displayPostedInvoices = _data["displayPostedInvoices"];
            this.displayExportedInvoices = _data["displayExportedInvoices"];
            this.displayInvoicesNeedingReview = _data["displayInvoicesNeedingReview"];
            this.displayInvoicesWithReviewOnHold = _data["displayInvoicesWithReviewOnHold"];
            this.displayReviewedInvoices = _data["displayReviewedInvoices"];
            this.recurringServiceEventMessage = _data["recurringServiceEventMessage"];
        }
    }

    static fromJS(data: any): Cp1PortalSettings {
        data = typeof data === 'object' ? data : {};
        let result = new Cp1PortalSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["isMembershipsEnabled"] = this.isMembershipsEnabled;
        data["isSchedulerEnabled"] = this.isSchedulerEnabled;
        data["host"] = this.host;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["companyName"] = this.companyName;
        if (Array.isArray(this.downloadInvoiceBusinessUnitIds)) {
            data["downloadInvoiceBusinessUnitIds"] = [];
            for (let item of this.downloadInvoiceBusinessUnitIds)
                data["downloadInvoiceBusinessUnitIds"].push(item);
        }
        data["displayCancelledMemberships"] = this.displayCancelledMemberships;
        data["displayExpiredMemberships"] = this.displayExpiredMemberships;
        data["displaySuspendedMemberships"] = this.displaySuspendedMemberships;
        data["displayPendingInvoices"] = this.displayPendingInvoices;
        data["displayPostedInvoices"] = this.displayPostedInvoices;
        data["displayExportedInvoices"] = this.displayExportedInvoices;
        data["displayInvoicesNeedingReview"] = this.displayInvoicesNeedingReview;
        data["displayInvoicesWithReviewOnHold"] = this.displayInvoicesWithReviewOnHold;
        data["displayReviewedInvoices"] = this.displayReviewedInvoices;
        data["recurringServiceEventMessage"] = this.recurringServiceEventMessage;
        return data;
    }
}

export interface ICp1PortalSettings {
    isEnabled: boolean;
    isMembershipsEnabled: boolean;
    isSchedulerEnabled: boolean;
    host: string;
    email: string;
    phone: string;
    logo: string;
    companyName: string;
    downloadInvoiceBusinessUnitIds: number[] | undefined;
    displayCancelledMemberships: boolean;
    displayExpiredMemberships: boolean;
    displaySuspendedMemberships: boolean;
    displayPendingInvoices: boolean;
    displayPostedInvoices: boolean;
    displayExportedInvoices: boolean;
    displayInvoicesNeedingReview: boolean;
    displayInvoicesWithReviewOnHold: boolean;
    displayReviewedInvoices: boolean;
    recurringServiceEventMessage: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}